import { artistRewards, artists } from "@/mocks/artistData";
import { Link } from "react-router-dom";

interface ClaimedReward {
  rewardId: string;
  claimedAt: string;
  status: "active" | "used" | "expired";
  code?: string;
}

const MY_CLAIMED: ClaimedReward[] = [
  { rewardId: "reward-003", claimedAt: "2026-03-20", status: "active", code: "SEOL-DGTL-4892" },
  { rewardId: "reward-004", claimedAt: "2026-04-01", status: "active", code: "SEOL-EXCL-7731" },
  { rewardId: "reward-009", claimedAt: "2026-02-15", status: "used" },
  { rewardId: "reward-010", claimedAt: "2026-04-02", status: "active", code: "BMOON-OST-2241" },
  { rewardId: "reward-013", claimedAt: "2026-03-28", status: "active", code: "CINE-VID-5548" },
];

const CAT_COLOR: Record<string, string> = {
  digital: "#4fc3f7",
  exclusive: "#c77dff",
  credit: "#ffd60a",
  offline: "#ff6eb4",
};

const STATUS_INFO: Record<string, { label: string; color: string }> = {
  active: { label: "사용 가능", color: "#4ade80" },
  used: { label: "사용됨", color: "#ffffff40" },
  expired: { label: "만료됨", color: "#ff4757" },
};

export default function MyRewards() {
  return (
    <div>
      <h3 className="text-white font-bold text-base mb-4 flex items-center gap-2">
        <i className="ri-gift-line text-[#ff6eb4]" />
        수령한 리워드
        <span className="text-white/30 text-sm font-normal">{MY_CLAIMED.length}개</span>
      </h3>

      <div className="flex flex-col gap-3">
        {MY_CLAIMED.map((claimed) => {
          const reward = artistRewards.find((r) => r.id === claimed.rewardId);
          if (!reward) return null;
          const artist = artists.find((a) => a.id === reward.artistId);
          const catColor = CAT_COLOR[reward.category] || "#ffffff";
          const statusInfo = STATUS_INFO[claimed.status];

          return (
            <div
              key={claimed.rewardId}
              className={`p-4 rounded-xl border transition-all ${
                claimed.status === "used"
                  ? "border-white/5 bg-white/[0.01] opacity-60"
                  : "border-white/8 bg-white/[0.03] hover:border-white/15"
              }`}
            >
              <div className="flex items-center gap-4">
                {/* Image */}
                <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0">
                  <img src={reward.image} alt={reward.title} className="w-full h-full object-cover object-top" />
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                      <p className="text-white text-sm font-semibold truncate">{reward.title}</p>
                      <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                        <span className="text-xs px-2 py-0.5 rounded-full font-semibold" style={{ background: `${catColor}18`, color: catColor }}>
                          {reward.categoryLabel}
                        </span>
                        {artist && <span className="text-white/30 text-xs">{artist.name}</span>}
                      </div>
                    </div>
                    <div
                      className="flex items-center gap-1 text-xs font-semibold flex-shrink-0"
                      style={{ color: statusInfo.color }}
                    >
                      <i className={`ri-circle-fill text-[8px]`} />
                      {statusInfo.label}
                    </div>
                  </div>

                  {/* Code */}
                  {claimed.code && claimed.status === "active" && (
                    <div className="mt-2 flex items-center gap-2">
                      <div
                        className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-mono font-bold"
                        style={{ background: `${catColor}12`, border: `1px solid ${catColor}30`, color: catColor }}
                      >
                        <i className="ri-key-2-line" />
                        {claimed.code}
                      </div>
                      <button
                        onClick={() => navigator.clipboard.writeText(claimed.code!)}
                        className="w-7 h-7 flex items-center justify-center rounded-lg border border-white/10 text-white/40 hover:text-white hover:border-white/25 transition-all cursor-pointer"
                        title="복사"
                      >
                        <i className="ri-clipboard-line text-xs" />
                      </button>
                    </div>
                  )}

                  <p className="text-white/25 text-[10px] mt-1.5">수령일: {claimed.claimedAt}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-4 text-center">
        <Link
          to="/rewards"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl border border-white/15 text-white/60 text-sm font-medium hover:border-white/30 hover:text-white transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-gift-line" />
          리워드 더 보기
        </Link>
      </div>
    </div>
  );
}
